import React from 'react'
import "./readyToHelp.css"

function ReadyToHelp() {
  return (
   <section className='readytohelp_container'>
    <h2>We are here to help you</h2>
    <p>Connect with us today and see how our services can help you achieve your business goals.</p>
    <a href="./services"><button className='readytohelp_btn'>Get Started</button></a>
   </section>
  )
}

export default ReadyToHelp